import proj4 from 'proj4';
import { PolygonClippedGridSystem, extentFromPolygon, } from '@zwaarcontrast/ol-graticule';
import { ProjectedGridSystem, registerCRS, } from '@zwaarcontrast/ol-graticule-projected';
import { NEI_EQUATORIAL_ZONE_CRS, NEI_EQUATORIAL_ZONE_PROJ4, NEI_EQUATORIAL_ZONE_VALIDITY_WGS84, NEI_SOUTHERN_ZONE_CRS, NEI_SOUTHERN_ZONE_PROJ4, NEI_SOUTHERN_ZONE_VALIDITY_WGS84, } from './zones.js';
const EXTENT_MARGIN_M = 100_000;
/** Grid system for one zone, clipped to its WGS84 validity ring. */
function createNEIGridSystem(crs, proj4Def, validityWgs84, options) {
    registerCRS(crs, proj4Def);
    const toGrid = proj4('EPSG:4326', proj4Def);
    const projected = validityWgs84.map(([lon, lat]) => {
        const [x, y] = toGrid.forward([lon, lat]);
        return [x ?? 0, y ?? 0];
    });
    return new PolygonClippedGridSystem({
        source: new ProjectedGridSystem({
            ...options,
            crs,
            extent: extentFromPolygon(projected, EXTENT_MARGIN_M),
        }),
        clipPolygon: { rings: [validityWgs84], crs: 'EPSG:4326' },
    });
}
export function createNEISouthernZoneGridSystem(options) {
    return createNEIGridSystem(NEI_SOUTHERN_ZONE_CRS, NEI_SOUTHERN_ZONE_PROJ4, NEI_SOUTHERN_ZONE_VALIDITY_WGS84, options);
}
export function createNEIEquatorialZoneGridSystem(options) {
    return createNEIGridSystem(NEI_EQUATORIAL_ZONE_CRS, NEI_EQUATORIAL_ZONE_PROJ4, NEI_EQUATORIAL_ZONE_VALIDITY_WGS84, options);
}
/** Every NEI grid zone, keyed by CRS. */
export const NEI_GRIDS = {
    [NEI_SOUTHERN_ZONE_CRS]: {
        crs: NEI_SOUTHERN_ZONE_CRS,
        name: 'NEI Southern Zone',
        proj4: NEI_SOUTHERN_ZONE_PROJ4,
        createGridSystem: () => createNEISouthernZoneGridSystem(),
        validityWgs84: [NEI_SOUTHERN_ZONE_VALIDITY_WGS84],
    },
    [NEI_EQUATORIAL_ZONE_CRS]: {
        crs: NEI_EQUATORIAL_ZONE_CRS,
        name: 'NEI Equatorial Zone',
        proj4: NEI_EQUATORIAL_ZONE_PROJ4,
        createGridSystem: () => createNEIEquatorialZoneGridSystem(),
        validityWgs84: [NEI_EQUATORIAL_ZONE_VALIDITY_WGS84],
    },
};
//# sourceMappingURL=grids.js.map